import { useAuthenticatedQuery } from '../../useAuthenticatedQuery.js';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_ADMIN_URL, FUNCTION_KEY, PROJECT_SCOPE } from '../../../config.js';
import useUser from '../../useUser.js';
import logError from '../../metadata/ErrorLogging.js';

export default function useUserList(orgId = null) {
  const { user:userDetails } = useUser();

  const fetchUsers = async (token) => {
    try {
      const response = await axios.get(`${API_ADMIN_URL}users?org_id=${orgId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'x-functions-key': FUNCTION_KEY
        }
      });
      return response.data;
    } catch (error) {
      logError('Failed to load users in useUserList', error, {}); // Error during fetch
      throw error;
    }
  };
  
  const { data: usersData = [], isLoading, refetch, error } = useAuthenticatedQuery(['admin_users', userDetails?.id, orgId], fetchUsers, [PROJECT_SCOPE], {
    staleTime: 300000, //Data will be considered stale after 5 minutes
  });

  return { usersData, loadingUsers: isLoading, refetchUsers: refetch, usersError: error };
}

useUserList.propTypes = {
  orgId: PropTypes.number
}